
import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import Navbar from '../../Components/Navbar';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../Secretary/Table.css';
import { API_BASE_URL } from '../../config';
import SelectYear from '../../Components/SelectYear'; // Import the SelectYear component

export default function ViewApplicationD() {
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedGrantType, setSelectedGrantType] = useState('');
  const [applications, setApplications] = useState([]);
  const [filteredApplications, setFilteredApplications] = useState([]);
  const navigate = useNavigate(); // Initialize useNavigate hook

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/ViewApplication.php`);
        setApplications(response.data);
        setFilteredApplications(response.data); // Initialize with all data
      } catch (error) {
        console.error('Error fetching applications:', error);
      }
    };

    fetchApplications();
  }, []);

 useEffect(() => {
  let filtered = applications;

  if (selectedStatus) {
    filtered = filtered.filter(app => app.Status === selectedStatus);
  }

  if (selectedYear) {
    filtered = filtered.filter(
      app => new Date(app.submittedDate).getFullYear() === parseInt(selectedYear)
    );
  }

  if (selectedGrantType) {
    filtered = filtered.filter(app => app.app_type === selectedGrantType);
  }

  setFilteredApplications(filtered);
}, [selectedStatus, selectedYear, selectedGrantType, applications]);

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
  };

  const handleYearChange = (year) => {
    setSelectedYear(year);
  };

   const handleGrantTypeChange = (e) => {
    setSelectedGrantType(e.target.value);
  };

  const handleViewClick = async (app_ID) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/ViewSubmittedApplicationPDF.php?app_ID=${app_ID}`, {
        responseType: 'blob', // Expect binary data (PDF file)
      });
  
      // Create a Blob object and generate a download link
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      //link.download = `Application_${app_ID}.pdf`; // Set the downloaded file's name
      link.download = `Application_${new Date().getFullYear()}_${app_ID}.pdf`;
      link.click();
  
      // Cleanup
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Error downloading the file:', error);
      alert('An error occurred while downloading the application.');
    }
  };

  const handleClick = (app_ID) => {
    navigate(`/moredetails/${app_ID}`); // Correctly use template literal
  };

  const handleDeleteClick = async (app_ID) => {
    if (window.confirm('Are you sure you want to delete this application?')) {
      try {
        // Send the request to delete the application
        const response = await axios.post(`${API_BASE_URL}/DeleteApplication.php`, { app_ID });
  
        if (response.data.success) {
          // Update state to remove the deleted application
          setApplications(applications.filter((app) => app.app_ID !== app_ID));
          alert('Application deleted successfully.');
        } else {
          alert(`Failed to delete application: ${response.data.message}`);
        }
      } catch (error) {
        console.error('Error deleting application:', error);
        alert('An error occurred while deleting the application.');
      }
    }
  };

  return (
    <div>
      <Navbar />
      <h1 className="page-title">View Applications</h1>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th colSpan={8} className="dropdown-row">
              <label htmlFor="year-select">Year: </label>
              <SelectYear selectedYear={selectedYear} handleYearChange={handleYearChange} /> 

              <label htmlFor="status-select">Grant Type: </label>
              <select id="status-select" onChange={handleGrantTypeChange}>
                <option value="">All</option>
                <option value="MRG">MRG</option>
                <option value="URG">URG</option>
                
              </select>
              <label htmlFor="status-select">Status: </label>
              <select id="status-select" onChange={handleStatusChange}>
                <option value="">Select Status</option>
                <option value="Submitted">Submitted</option>
                <option value="Shortlisted">Shortlisted</option>
                <option value="Granted">Granted</option>
                <option value="Pending Approvals">Pending Approvals</option>
                <option value="Reviewers Comments">Reviewers Comments</option>
                <option value="Rejected">Rejected</option>
                <option value="Deny">Deny</option>
              </select>

              
            </th>
          </tr>
          <tr>
            <th>No</th>
            <th>Appliant Name</th> 
            <th>Application Id</th>
            <th>Project Title</th>
            <th>Submitted Date</th>
            <th>Status</th>
            <th>View Grant (PDF)</th>
            <th>Application Details</th>
            <th>Delete Application</th>
          </tr>
        </thead>
        <tbody>
          {filteredApplications.map((app, index) => (
            <tr key={app.app_ID}>
               <td>{index + 1}</td>
              <td>{app.name}</td>
              <td>{`${app.app_ID}_${app.app_type}_${app.submittedDate ? new Date(app.submittedDate).getFullYear() : ""}`}</td>
              <td>{app.projectTitle}</td>
              <td>{app.submittedDate}</td>
              <td>{app.Status}</td> {/* Display the status from application table */}
              <td>
                <button 
                  className="view-button" // Add your custom class name for styling
                  onClick={() => handleViewClick(app.app_ID)} // Handle button click
                >
                 Application
                </button>
              </td>
              <td>
                <button 
                  className="moreDetails-button" // Add your custom class name for styling
                  onClick={() => handleClick(app.app_ID)} // Navigate to More Details
                >
                 More Details
                </button>
              </td>
              <td>
                <button className="delete-button" onClick={() => handleDeleteClick(app.app_ID)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
